<template>
  <div class='container'
       ref="containerBox"
       @scroll="handleScroll">
    <div ref="stickyBox"
         :class="[{ sticky: isSticky }, { box: !isSticky }]"
         :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky"
                 :scrollToTop="scrollToTop"></titlePage>
    </div>
    <div class='contentBox'>
      <div class="content">
        <div class="top-card">
          <div class="top-card-content">
            <!-- 左侧：主金额卡片 -->
            <div class="main-amount-card">
              <div>
                <div class="amount-label">账户佣金金额（元）</div>
                <div class="amount-value">{{ info.commission_amount || '0' }}</div>
              </div>
              <el-button type="primary"
                         class="withdraw-btn"
                         @click="Withdrawal">提现</el-button>
            </div>

            <!-- 右侧：金额列表 -->
            <div class="amount-list">
              <div class="amount-item">

                <div class="amount-item-label">
                  <div class="d1"></div>已提现（元）
                </div>
                <div class="amount-item-value">{{info.withdrawn || '0'}}</div>
              </div>
              <div class="amount-item">
                <div class="amount-item-label">
                  <div class="d2"></div>未提现（元）
                </div>
                <div class="amount-item-value">{{info.balance || '0'}}</div>
              </div>
              <div class="amount-item">
                <div class="amount-item-label">
                  <div class="d3"></div>个人佣金（元）
                </div>
                <div class="amount-item-value">{{info.personal_commission || '0'}}</div>
              </div>
              <div class="amount-item">
                <div class="amount-item-label">
                  <div class="d4"></div>团队佣金（元）
                </div>
                <div class="amount-item-value">{{info.team_commission || '0'}}</div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px;background:#fff ;padding:  30px 20px 10px 20px;border-radius: 8px;"
             class="flex-column">
          <div class="flex-between">
            <div class="flex-between"
                 style="flex-direction: column; flex: 0 0 30%;align-items: flex-start;">
              <div class="text"
                   style="font-size: 18px;margin-bottom: 10px;">已获得奖金(元)</div>
              <div class="price flex-between"
                   style="width: 40%;">
                <span style="font-size: 24px;">{{ total_fee || 0 }} </span>
                <span class="cursor"
                      @click="Withdrawal">提现</span>
              </div>
            </div>
            <el-input placeholder="请输入内容"
                      v-model="searchForm.keyword"
                      class="input-with-select"
                      style="width: 60%;border:2px solid #0092FF;border-radius: 4px;">
              <el-button slot="append"
                         icon="el-icon-search"
                         type="primary"
                         style="background: #0092FF;color: #fff;"
                         @click="search">搜索</el-button>
            </el-input>
          </div>
          <el-tabs v-model="searchForm.status"
                   @tab-click="handleClick"
                   style="margin-top: 20px;">
            <el-tab-pane label="已结算"
                         name="2"></el-tab-pane>
            <el-tab-pane label="未结算"
                         name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="list-box flex-column"
             style="margin-top: 30px;"
             v-if="list.length>0">
          <div class="list-item"
               style="display: flex; flex-direction: column;padding: 0;margin-right: 0;"
               v-for="(item, index) in list"
               :key="index">
            <div class="GradientBackground flex-between"
                 style="font-size: 18px;">
              <div>
                结算单号：{{ item.order_sn || '' }}
              </div>
              <div> {{ item.status == 1 ? '未结算' : '已结算' }}</div>
            </div>
            <div class="card"
                 style="border-radius: 0 0 10px 10px;">
              <div class="flex-between">
                <div class="flex"
                     style="margin: 10px 0;">
                  <div class="tags flex-column"
                       style="padding: 0 20px;">
                    <p>公司名称</p>
                    <p v-if="item.company">{{ item.company.company || '' }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 40px;">
                    <p>职位名称</p>
                    <p v-if="item.company">{{ item.company.title || '' }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 40px;">
                    <p>姓名</p>
                    <p>{{ item.people_name || '' }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 40px;">
                    <p>结算人次</p>
                    <p>{{ item.people || 0 }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 40px;">
                    <p>结算总额</p>
                    <p style="color: #0092FF;">{{ item.pay_fee || 0 }}</p>
                  </div>
                </div>
                <div style="margin: 10px 0;">
                  <el-button type="primary"
                             plain
                             @click="getDetails(item)">查看明细</el-button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- <div class="list-box flex-column"
             style="margin-top: 30px;"
             v-if="list.length==0">
          <div class="list-item"
               style="display: flex; flex-direction: column;align-items: center; padding: 0;margin-right: 0;">
            <div class="card">
              暂无更多 {{ list.length }}
            </div>
          </div>
        </div> -->

      </div>
    </div>
    <fotterVue></fotterVue>
  </div>
</template>

<script>
import titlePage from '@/components/titlePage.vue'
import fotterVue from '@/components/fotter.vue'
export default {
  name: '',
  components: {
    titlePage,
    fotterVue,
  },
  data() {
    return {
      searchForm: {
        keyword: '',
        status: '2',
        page: 1,
        size: 10,
      },
      typeList: [
        // { name: "销售人员", src: "image/index/icon1" },
        { name: '销售人员', src: 'require(`@/static/image/index/icon1.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon2.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon3.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon4.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon5.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon6.png`)' },
      ],
      list: [],
      total_fee: 0,
      isSticky: false,
      info: {},
      stickyBoxTop: 0,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.scrollToTop()
    this.getInfo()
    this.getMyOrderpayList()
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event, this.searchForm.status);
      this.searchForm.page = 1
      this.getMyOrderpayList()
    },
    getDetails(item) {
      this.$router.push({
        path: '/SettlementDetails',
        query: {
          id: item.id,
        },
      })
    },
    getInfo() {
      this.$api.index.UserIndex().then((res) => {
        console.log(res, '666')
        this.loading = false
        if (res.code == 200) {
          this.info = res.data.commission_stats
        }
      })
    },
    getMyOrderpayList() {
      if (this.searchForm.page == 1) {
        this.list = []
      }
      this.$api.index.getMyOrderpayList(this.searchForm).then((res) => {
        console.log(res, '666')
        this.loading = false
        if (res.code == 200) {
          this.list = [...this.list, ...res.data.list]
          console.log(this.list.length, 1666)
          this.isStatus = res.data.total > this.list.length ? true : false
          this.total_fee = res.data.total_fee
        }
      })
    },
    search() {
      this.searchForm.page = 1
      this.getMyOrderpayList()
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop
      const bottomOfWindow =
        this.$refs.containerBox.scrollHeight -
        this.$refs.containerBox.scrollTop -
        this.$refs.containerBox.clientHeight
      console.log(bottomOfWindow)
      if (this.isStatus == true && bottomOfWindow <= 50) {
        this.searchForm.page += 1
        this.isStatus = false
        this.getMyOrderpayList()
      }
    },
    scrollToTop() {
      this.$refs.containerBox.scrollTop = 0
    },
    Withdrawal() {
      this.$router.push({
        path: '/Withdrawal',
        query: {},
      })
    },
  },
  created() {
    this.getMyOrderpayList()
    console.log(this.list.length, 2333)
  },
}
</script>
<style lang='scss' scoped>
.contentBox {
  background: linear-gradient(0deg, #f6f8fe 0%, #f6f8fe 78%, #ceeaff 100%);
  margin-top: 60px;
  min-height: 55vh;
}

.content {
  padding: 30px 20px;
}

.top-card {
  //   background: #fff;
  border-radius: 8px;
  //   padding: 10px;
  margin-bottom: 30px;
}

.top-card-content {
  display: flex;
  gap: 20px;
  background: #fff;
}

.main-amount-card {
  position: relative;
  display: flex;
  //   flex-direction: column;
  justify-content: space-between;
  align-items: center;
  //   border-radius: 8px;
  padding: 20px;
  color: #fff;
  background: url('../../static/image/per_bg.png') no-repeat center center;
  background-size: 100% 100%;
  flex: 0 0 35%;
}

.amount-label {
  font-size: 14px;
  color: #55719c;
  margin-bottom: 8px;
}

.amount-value {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1e202c;
}

.withdraw-btn {
  background: #0084ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 20px;
  font-size: 14px;
}

.rate-tag {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff4757;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
}

.amount-list {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.amount-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  border-right: 1px solid #eee;

  &:last-child {
    border-right: none;
  }
}

.amount-item-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.amount-item-value {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.serchBox {
  width: 70%;
  border: 2px solid #0092ff;
  border-radius: 6px;
}

.tags {
  padding: 0 10px;
  font-weight: 400;
  font-size: 14px;
  color: #666;

  p {
    // margin: 0;
    // padding: 0;

    &:last-child {
      color: #333333;
    }
  }
}

.tagsBorder {
  border-left: 1px solid #d7d7d7;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}

::v-deep .el-tabs__active-bar {
  background-color: transparent !important;
}

::v-deep .el-input--suffix .el-input__inner {
  padding: 23px 30px;
}

::v-deep .el-input-group__append {
  // background: rgb(42, 163, 254) !important;
  position: relative;
  width: 90px;

  .el-button {
    position: absolute;
    // top: 10px;
    // margin-top: -10px;

    top: 7px;
    right: 19px;
    height: 44px;
    width: 91px;
  }
}
.d1 {
  width: 8px;
  height: 8px;
  background: #10b981;
  border-radius: 50%;
  margin-right: 10px;
}
.d2 {
  width: 8px;
  height: 8px;
  background: #f59e0b;
  border-radius: 50%;
  margin-right: 10px;
}
.d3 {
  width: 8px;
  height: 8px;
  background: #007cff;
  border-radius: 50%;
  margin-right: 10px;
}
.d4 {
  width: 8px;
  height: 8px;
  background: #8b5cf6;
  border-radius: 50%;
  margin-right: 10px;
}
</style>